import * as actionTypes from './actionTypes';

export const resetSpeedBoostState = () => {
  return {
    type: actionTypes.RESET_SPEED_BOOST_STATE,
    
  };
}
export const initSpeedBoostLogsStart = () => {
  return {
    type: actionTypes.INIT_SB_LOGS_START
  };
};

export const setSpeedBoostLogs = (logsList) => {
  return {
    type: actionTypes.SET_SB_LOGS,
    logsList: logsList
  };
};

export const fetchSpeedBoostLogsFailed = () => {
  return {
    type: actionTypes.FETCH_SB_LOGS_FAILED
  };
};


export const initSpeedBoostLogs = () => {

  return {
    type: actionTypes.INIT_SB_LOGS
  };
};

export const getSpeedBoostCheckDevices = () => (
  { type: actionTypes.DEVICES_GET_SPEED_BOOST }
);

export const getSpeedBoostCheckDevicesLoading = () => (
  { type: actionTypes.DEVICES_GET_SPEED_BOOST_LOADING }
);

export const getSpeedBoostCheckDevicesSuccess = (payload) => (
  { type: actionTypes.DEVICES_GET_SPEED_BOOST_SUCCESS, payload }
);

export const getSpeedBoostCheckDevicesFailure = (payload) => (
  { type: actionTypes.DEVICES_GET_SPEED_BOOST_FAILURE, payload }
);
